import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { isAuthenticated, isForbidden } from './core/guards/app-session/app-session.guard';
import { hasAdminProfile } from './core/guards/check-profile/check-profile.guard';
import { ForbiddenComponent } from './shared/pages/forbidden/forbidden.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'explorer',
  },
  {
    path: 'explorer',
    loadChildren: () => import('./modules/explorer/explorer.module').then(m => m.ExplorerModule),
    canActivate: [isAuthenticated],
  },
  {
    path: 'normateca',
    loadChildren: () => import('./modules/normateca/normateca.module').then(m => m.NormatecaModule),
    canActivate: [isAuthenticated, hasAdminProfile],
  },
  {
    path: 'profiles',
    loadChildren: () => import('./modules/profiles/profiles.module').then(m => m.ProfilesModule),
    canActivate: [isAuthenticated, hasAdminProfile],
  },
  {
    path: 'system-users',
    loadChildren: () => import('./modules/system-users/system-users.module').then(m => m.SystemUsersModule),
    canActivate: [isAuthenticated, hasAdminProfile],
  },
  {
    path: 'reports',
    loadChildren: () => import('./modules/reports/reports.module').then(m => m.ReportsModule),
    canActivate: [isAuthenticated, hasAdminProfile],
  },
  {
    path: 'favorites',
    loadChildren: () => import('./modules/favorites/favorites.module').then(m => m.FavoritesModule),
    canActivate: [isAuthenticated],
  },
  {
    path: 'forbidden',
    component: ForbiddenComponent,
    canActivate: [isForbidden]
  },
  {
    path: '**',
    redirectTo: 'explorer',
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
